// extracted by mini-css-extract-plugin
var _1 = "VerificationVerifiersFields-module__animateUploadProgressBarWidth--kab8W";
var _2 = "VerificationVerifiersFields-module__animatedBackground--d4uKD";
var _3 = "VerificationVerifiersFields-module__avatarsWrapper--OTBET";
var _4 = "VerificationVerifiersFields-module__editPrimary--jfLVV";
var _5 = "VerificationVerifiersFields-module__empty--OBfY4";
var _6 = "VerificationVerifiersFields-module__primarySelect--XeWna";
var _7 = "VerificationVerifiersFields-module__secondVerifier--STVrq";
var _8 = "VerificationVerifiersFields-module__secondarySelect--Od6vY";
var _9 = "VerificationVerifiersFields-module__userInput--yKyxS";
var _a = "VerificationVerifiersFields-module__verifiers--mm9UP";
var _b = "VerificationVerifiersFields-module__verifiersItem--XyKii";
var _c = "VerificationVerifiersFields-module__verifiersTitle--ACKfn";
var _d = "VerificationVerifiersFields-module__warning--mNk0V";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "avatarsWrapper", _4 as "editPrimary", _5 as "empty", _6 as "primarySelect", _7 as "secondVerifier", _8 as "secondarySelect", _9 as "userInput", _a as "verifiers", _b as "verifiersItem", _c as "verifiersTitle", _d as "warning" }
